exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:768px) and (max-width:991px){.section_footer .name{margin-top:0!important}}@media (min-width:576px) and (max-width:767px){.section_footer .name{margin-top:0!important}}@media (max-width:575px){.section_footer .name{margin-top:0!important}}.section_footer{background:#464646;padding:20px 0;color:#fff;font-size:20px}.section_footer a{color:#fff;line-height:26px}.section_footer .H2{color:#fff;text-align:left}.section_footer img{margin-top:10px;max-width:100%;height:auto}.section_footer .name{font-weight:700;font-size:32px;line-height:38px;font-family:Open Sans Condensed,sans-serif;margin-top:30px}.section_footer .addres{font-size:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cb23553e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Footer.vue
// module id = 259
// module chunks = 0